export const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST || "http://localhost:8080";
export const WEBSOCKET_HOST = process.env.REACT_APP_WEBSOCKET_HOST || "ws://localhost:8080";